import { Box, Button, Card, Text } from '@zillow/constellation-10';

import type { ReactNode } from 'react';

type NextStepCardProps = {
  icon: ReactNode;
  title: string;
  description: string;
  buttonLabel: string;
  buttonEmphasis: 'filled' | 'outlined';
  href: string;
  onClick: () => void;
  'data-testid'?: string;
};

const NextStepCard = ({
  icon,
  title,
  description,
  buttonLabel,
  buttonEmphasis,
  href,
  onClick,
  'data-testid': dataTestId,
}: NextStepCardProps) => {
  return (
    <Card data-testid={dataTestId} outlined elevated={false} dividers={false} css={{ borderRadius: '300' }}>
      <Box
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '400',
        }}
      >
        <Box css={{ display: 'flex', alignItems: 'center', gap: '400' }}>
          <Box css={{ flexShrink: 0 }}>{icon}</Box>
          <Box css={{ display: 'flex', flexDirection: 'column' }}>
            <Text textStyle="body-bold">{title}</Text>
            <Text textStyle="body-sm" color="text.subtle">
              {description}
            </Text>
          </Box>
        </Box>

        <Box css={{ flexShrink: 0 }}>
          <Button asChild size="sm" emphasis={buttonEmphasis} tone="brand" css={{ borderRadius: '300' }}>
            <a href={href} onClick={onClick}>
              {buttonLabel}
            </a>
          </Button>
        </Box>
      </Box>
    </Card>
  );
};

export default NextStepCard;
